export const ADD = 'one-state-skeleton/add';
export const SET = 'one-state-skeleton/set';
export const RESET = 'one-state-skeleton/reset';